import { Stack, Typography, useTheme } from "@mui/material";

const CaseStudyBulletOnlyRegion = ({title, data}) => {
    const theme = useTheme();
    
    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='start'
                spacing={{xs: 1, md: 2}}
            >
                <Typography
                    fontWeight={600}
                    fontSize={{xs: 12, md: 16, lg: 24}}
                    textAlign='left'
                    color={theme.palette.text.primary}
                    lineHeight={1.5}
                >
                    {title}
                </Typography>

                {
                    data.map((item, index) => {
                        return <Stack
                            key={index}
                            direction='row'
                            justifyContent='start'
                            alignItems='start'
                        >
                            <Typography
                                fontWeight={600}
                                fontSize={{xs: 12, md: 12, lg: 14}}
                                textAlign="left"
                                lineHeight={2}
                                color={theme.palette.text.secondary}
                                pr={1}
                            >
                                {index + 1}.
                            </Typography>

                            <Typography
                                fontWeight={500}
                                fontSize={{xs: 12, md: 12, lg: 14}}
                                textAlign="justify"
                                lineHeight={2}
                                color={theme.palette.text.primary}
                            >
                                {item}
                            </Typography>
                        </Stack>
                    })
                }
            </Stack>
        </>
    );
}

export default CaseStudyBulletOnlyRegion;